import statsQuestion from './statsQuestion';
import contactField from './contactField';
import feedback from './feedback';

export default [statsQuestion, contactField, feedback];
